import axios from "axios";
import Avatar from "boring-avatars";
import { useEffect, useState } from "react";

type AvatarVariant =
  | "marble"
  | "beam"
  | "pixel"
  | "sunset"
  | "ring"
  | "bauhaus";

const CustomedAvatar = ({ id }: { id: string }) => {
  const [avatarInfo, setAvatarInfo] = useState<
    [AvatarVariant, string, string, string, string, string]
  >(["marble", "#fb6900", "#f63700", "#004853", "#007e80", "#00b9bd"]);
  const getUserAvatar = async () => {
    try {
      const response = await axios.get(
        `https://chamstudyland.com/api/fun_learning/get_avatar.php?id=${id}`
      );
      setAvatarInfo(response.data);
    } catch (error) {
      console.log("Avartar data not fetched", error);
    }
  };
  useEffect(() => {
    getUserAvatar();
  }, []);
  console.log("설정할 아바타 info", avatarInfo);

  return (
    <div>
      <Avatar
        name="marble"
        variant={avatarInfo[0] === null ? "marble" : avatarInfo[0]}
        colors={
          avatarInfo[0] === null
            ? ["#fb6900", "#f63700", "#004853", "#007e80", "#00b9bd"]
            : avatarInfo.slice(1)
        }
      />
    </div>
  );
};
export default CustomedAvatar;
